import { Modal, Card, Alert, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

import { TEMPLATE, ROOT_CONSTANT } from "../../constants";

import { ButtonLink } from "../../components";

import { APP_INFO } from "../../config";

import * as REDUX_ACTION from "../../services/redux/actions";

import styles from "../../components/ButtonModal/modules/common.module.css";

const { MODALS } = TEMPLATE.MODAL;

const ModalSuspend = (props) => {
  const { setmodal } = props;

  const dispatch = useDispatch();
  const onClickConfirmLogout = () =>
    dispatch(REDUX_ACTION.v1_user.user_sign_out_request());
  
  return (
    <Modal open={true} footer={null} width={450}>
      <div
        className={styles["content-container"]}
        style={{ textAlign: "left" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src={MODALS[setmodal]?.img}
              alt="the logo"
              style={{ padding: "7px", width: "50px" }}
            />
          </Card>
        </div>

        <h3 className={styles["title"]}>{MODALS[setmodal]?.title}</h3>
        <p className={styles.textCard}>
          <div>
            Your account is currently suspended, which means you can’t access
            your Bolt Central Portal.{" "}
          </div>
          <Alert
            type="error"
            message={`You need to contact Bolt Advance admin for further clarification.`}
            style={{ color: "red", marginTop: "10px" }}
            icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
            showIcon={true}
          />
        </p>

        <div className={styles["buttons"]}>
          <ButtonLink
            onClick={onClickConfirmLogout}
            style={{ color: "red", marginTop: "8px" }}
          >
            Logout
          </ButtonLink>
          <Button
            onClick={() => window.open(APP_INFO.WHATSAPP_NUMBER, "_blank")}
            className={`${styles["active"]}`}
            style={{ borderRadius: "5px", height: "40px" }}
          >
            <span style={{ display: "inline-flex" }}>
              Contact bolt admin &nbsp;
              <img
                src={ROOT_CONSTANT.IMG.ICON.MODAL.icon_whatsapp}
                alt="whatsapp"
              />
            </span>
          </Button>
        </div>
        {/* </div> */}
      </div>
    </Modal>
  );
};

export default ModalSuspend;
